import { createContext } from 'react';

/**
 * Represents the tenant configuration context.
 */
export const ConfigContext = createContext({ config: {} });
